import { createSlice } from "@reduxjs/toolkit";

export const contactPayloadData = createSlice({
  name: "contactPayloadData",
  initialState: {},
  reducers: {
    setContactPayloadData: (_, action) => {
      return action.payload;
    },
  },
});

export const { setContactPayloadData } = contactPayloadData.actions;

export default contactPayloadData.reducer;
